import type { ParseKeys } from 'i18next';

import { automationErrorCode } from '@/entities/tracker-automation';

type TrackersKey = ParseKeys<'trackers'>;

/** What each `code` workspace-api puts on a refused automation or AI request means. */
const AUTOMATION_ERROR_KEYS: Record<string, TrackersKey> = {
  agent_not_allowed: 'trackersBoard.automationAi.agent.notAllowed',
  agent_workspace_required: 'trackersBoard.automationAi.agent.workspaceRequired',
  ai_budget_forbidden: 'trackersBoard.automationErrors.aiBudgetForbidden',
  ai_budget_reached: 'trackersBoard.automationAi.describe.budget',
  ai_model_not_allowed: 'trackersBoard.automationErrors.aiModelNotAllowed',
  automation_ai_fill_self_trigger: 'trackersBoard.automationErrors.aiFillSelfTrigger',
  automation_author_cannot_edit: 'trackersBoard.automationErrors.authorCannotEdit',
  automation_create_cycle: 'trackersBoard.automationErrors.createCycle',
  automation_edit_forbidden: 'trackersBoard.automationErrors.editForbidden',
  automation_limit_reached: 'trackersBoard.automationErrors.limitReached',
  automation_people_outside_organization: 'trackersBoard.automationErrors.peopleOutsideWorkspace',
  automation_people_outside_workspace: 'trackersBoard.automationErrors.peopleOutsideWorkspace',
  automation_proposal_invalid: 'trackersBoard.automationAi.describe.invalid',
  automation_proposal_malformed: 'trackersBoard.automationAi.describe.malformed',
  automation_paused: 'trackersBoard.automationErrors.paused',
  automation_proposal_not_understood: 'trackersBoard.automationAi.describe.notUnderstood',
  automation_row_loop: 'trackersBoard.automationErrors.rowLoop',
  automation_target_board_not_found: 'trackersBoard.automationErrors.targetBoardNotFound',
  tracker_view_only: 'trackersBoard.automationErrors.trackerViewOnly',
};

/**
 * The message key for why an automation request failed: the server's reason
 * where it gave one we know, otherwise `fallback`, the caller's own words for
 * what did not happen.
 */
export function automationErrorKey(error: unknown, fallback: TrackersKey): TrackersKey {
  const code = automationErrorCode(error);
  return code && Object.hasOwn(AUTOMATION_ERROR_KEYS, code)
    ? AUTOMATION_ERROR_KEYS[code]
    : fallback;
}
